import { Injectable } from '@angular/core';
import { CartCalculationRule } from './cart.domain';
import { CartItemPriceCalculationRule } from './rules/cart-item-price-calculation.rule';
import { CartItemPriceUnitCalculationRule, CartItemProductChannelRule, CartItemSyncRule, CartStockCalculationRule } from './rules';

@Injectable({
	providedIn: 'root',
})
export class CartFactoryService {

	/**
	 * Devuelve las reglas de precios de los items segun el orden requerido
	 */
	public getItemPriceRules(): CartCalculationRule[] {
		return [
			new CartItemProductChannelRule(),
			new CartItemPriceCalculationRule(),
			new CartItemPriceUnitCalculationRule(),
		];
	}

	/**
	 * Devuelve las reglas de stock de los items segun el orden requerido
	 * @returns CartStockCalculationRule[]
	 */
	public getCartStockRules(): CartCalculationRule[] {
		return [
			new CartStockCalculationRule(),
		];
	}

	/**
	 * Devuelve las reglas para sincronizar los items del carrito con los datos de cloud.
	 * @returns CartCalculationRule[]
	 */
	public getCartItemSyncRules(): CartCalculationRule[] {
		return [
			new CartItemSyncRule(),
			new CartItemPriceCalculationRule(),
			new CartItemPriceUnitCalculationRule(),
		];
	}
}
